module.exports = __webpack_public_path__ + "img/pos-group.37bb2d9d.svg";